import e from "./ExamplePicker.vue.js";
import { filterClientsByQuery as t } from "../helpers/filter-clients-by-query.js";
import { findClient as n } from "../helpers/find-client.js";
import { operationToHar as r } from "../helpers/operation-to-har/operation-to-har.js";
import { generateCodeSnippet as i } from "../helpers/generate-code-snippet.js";
import { getCustomCodeSamples as a } from "../helpers/get-custom-code-samples.js";
import { getClients as ee } from "../helpers/get-clients.js";
import { getSecrets as te } from "../helpers/get-secrets.js";
import o from "./HttpMethod.vue.js";
import { Fragment as s, computed as c, createBlock as l, createCommentVNode as u, createElementBlock as d, createElementVNode as f, createSlots as ne, createTextVNode as p, createVNode as m, defineComponent as h, normalizeClass as re, onBeforeMount as ie, openBlock as g, ref as _, renderSlot as v, toDisplayString as y, unref as b, useId as ae, watch as x, watchEffect as oe, withCtx as S } from "vue";
import { ScalarCard as C, ScalarCardFooter as se, ScalarCardHeader as ce, ScalarCardSection as w } from "@scalar/components/card";
import { ScalarCodeBlock as le } from "@scalar/components/code-block";
import { ScalarButton as T } from "@scalar/components/button";
import { ScalarIconCaretDown as ue } from "@scalar/icons";
import { ScalarCombobox as de } from "@scalar/components/combobox";
import { ScalarVirtualText as fe } from "@scalar/components/virtual-text";
import { freezeElement as pe } from "@scalar/helpers/dom/freeze-element";
import { getResolvedRef as E } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { getOperationExamples as D, resolveOperationExamples as O } from "@scalar/workspace-store/helpers/operation-examples";
import { useExampleVisibility as k, useExternalExamples as A } from "@scalar/workspace-store/helpers/use-external-examples";
//#region src/code-example/components/CodeExample.vue?vue&type=script&setup=true&lang.ts
var j = ["innerHTML"], M = {
	key: 1,
	class: "text-c-2 flex h-full w-fit items-center px-0.5 py-0 text-base font-normal",
	"data-testid": "client-picker"
}, N = {
	key: 0,
	class: "text-c-2 p-4",
	role: "status"
}, P = {
	key: 1,
	class: "text-c-2 p-4",
	role: "status"
}, F = ["id"], I = {
	key: 0,
	class: "request-card-footer-addon"
}, L = {
	key: 1,
	class: "request-card-footer-start"
}, R = { class: "request-header" }, z = /*@__PURE__*/ h({
	__name: "CodeExample",
	props: {
		codeSampleUnavailable: { default: "No code sample available for this example." },
		clientPickerLabel: { default: "Change code sample language" },
		clientSearchLabel: { default: "Search clients" },
		codeSampleLabel: { default: "Code sample" },
		integration: {},
		clientOptions: {},
		selectedClient: {},
		selectedServer: { default: null },
		selectedContentType: {},
		selectedExample: {},
		eventBus: {},
		securitySchemes: { default: () => [] },
		method: {},
		path: {},
		operation: {},
		fallback: { type: Boolean },
		generateLabel: { type: Function },
		isWebhook: { type: Boolean },
		globalCookies: {},
		openapiVersion: {},
		requestBodyCompositionSelection: {}
	},
	emits: ["update:exampleKey"],
	setup(h, { emit: z }) {
		let B = z, V = c(() => {
			let e = E(h.operation.requestBody)?.content ?? {}, t = h.selectedContentType || Object.keys(e)[0];
			return t ? e[t]?.examples ?? {} : {};
		}), H = _(""), U = (e) => {
			let t = Object.keys(V.value);
			return e && t.includes(e) ? e : H.value && t.includes(H.value) ? H.value : t[0] ?? "";
		};
		ie(() => {
			H.value = U(h.selectedExample);
		}), x(() => h.selectedExample, (e) => {
			H.value = U(e);
		}), x(() => h.selectedContentType, () => {
			Object.keys(V.value).includes(H.value) || (H.value = U(h.selectedExample));
		}), oe(() => {
			B("update:exampleKey", H.value);
		});
		let me = (e) => {
			H.value = e, h.eventBus.emit("workspace:update:selected-example", e);
		}, W = c(() => a(h.operation)), G = c(() => ee(W.value.samples, h.clientOptions, W.value.label)), K = c(() => G.value.reduce((e, t) => e + t.options.length, 0)), q = _(n(G.value, h.selectedClient));
		x([() => h.selectedClient, G], ([e]) => {
			let t = n(G.value, e);
			t && (q.value = t);
		});
		let he = c(() => [h.clientPickerLabel, q.value?.title].filter(Boolean).join(": ")), ge = c(() => [h.codeSampleLabel, q.value?.title].filter(Boolean).join(": ")), J = _(null), _e = k(J), Y = A(() => D(h.operation, H.value, h.selectedContentType), () => _e.value), X = c(() => O(h.operation, H.value, h.selectedContentType, Y.resolve)), Z = c(() => Object.keys(V.value).length > 1), Q = c(() => {
			if (!h.isWebhook) return null;
			try {
				return r({
					operation: X.value,
					method: h.method,
					path: h.path,
					example: H.value,
					openapiVersion: h.openapiVersion,
					requestBodyCompositionSelection: h.requestBodyCompositionSelection,
					defaultDisabledParameters: !0
				});
			} catch (e) {
				return console.error("[webhookHar]", e), null;
			}
		}), $ = c(() => h.isWebhook ? Q.value?.postData?.text ?? "" : i({
			defaultDisabledParameters: !0,
			includeDefaultHeaders: h.integration === "client",
			clientId: q.value?.id,
			customCodeSamples: W.value.samples,
			operation: X.value,
			method: h.method,
			path: h.path,
			contentType: h.selectedContentType,
			server: h.selectedServer,
			securitySchemes: h.securitySchemes,
			example: H.value,
			globalCookies: h.globalCookies,
			openapiVersion: h.openapiVersion,
			requestBodyCompositionSelection: h.requestBodyCompositionSelection
		})), ve = c(() => h.isWebhook ? ye.value : q.value?.lang), ye = c(() => {
			if (!Q.value?.postData) return "json";
			let e = Q.value.postData.mimeType;
			return e?.includes("json") ? "json" : e?.includes("xml") ? "xml" : e?.includes("yaml") || e?.includes("yml") ? "yaml" : e?.includes("text/plain") ? "text" : "json";
		}), be = c(() => te(h.securitySchemes)), xe = (e) => {
			if (J.value) {
				let e = pe(J.value.$el);
				setTimeout(() => {
					e();
				}, 300);
			}
			q.value = e, e && h.eventBus.emit("workspace:update:selected-client", e.id);
		}, Se = c(() => ($.value?.length ?? 0) > 2e4), Ce = ae();
		return (n, r) => $.value === null || $.value || b(Y).pending.value ? (g(), l(b(C), {
			key: 0,
			ref_key: "elem",
			ref: J,
			class: "request-card dark-mode"
		}, {
			default: S(() => [
				m(b(ce), { class: "pr-2.5" }, ne({
					default: S(() => [
						r[1] ||= f("span", { class: "sr-only" }, "Request Example for", -1),
						m(o, {
							as: "span",
							class: "request-method",
							method: h.method
						}, null, 8, ["method"]),
						h.generateLabel ? (g(), d("span", {
							key: 0,
							innerHTML: h.generateLabel()
						}, null, 8, j)) : u("", !0),
						v(n.$slots, "header", {}, void 0, !0)
					]),
					_: 2
				}, [!h.isWebhook && K.value ? {
					name: "actions",
					fn: S(() => [K.value > 1 ? (g(), l(b(de), {
						key: 0,
						class: "max-h-80",
						filterFn: b(t),
						inputLabel: h.clientSearchLabel,
						modelValue: q.value,
						options: G.value,
						placement: "bottom-end",
						teleport: "",
						"onUpdate:modelValue": r[0] ||= (e) => xe(e)
					}, {
						default: S(() => [m(b(T), {
							"aria-label": he.value,
							class: "text-c-2 hover:text-c-1 flex h-full w-fit gap-1.5 px-0.5 py-0 text-base font-normal",
							"data-testid": "client-picker",
							variant: "ghost"
						}, {
							default: S(() => [p(y(q.value?.title) + " ", 1), m(b(ue), {
								class: "ui-open:rotate-180 mt-px size-3 transition-transform duration-100",
								weight: "bold"
							})]),
							_: 1
						}, 8, ["aria-label"])]),
						_: 1
					}, 8, [
						"filterFn",
						"inputLabel",
						"modelValue",
						"options"
					])) : (g(), d("span", M, y(q.value?.title), 1))]),
					key: "0"
				} : void 0]), 1024),
				m(b(w), { class: "request-editor-section custom-scroll p-0" }, {
					default: S(() => [b(Y).pending.value ? (g(), d("div", N, [b(Y).failed.value ? (g(), d(s, { key: 0 }, [r[3] ||= p(" Could not load this example. ", -1), m(b(T), {
						size: "sm",
						variant: "ghost",
						onClick: b(Y).retry
					}, {
						default: S(() => [...r[2] ||= [p(" Retry ", -1)]]),
						_: 1
					}, 8, ["onClick"])], 64)) : (g(), d(s, { key: 1 }, [p("Loading example…")], 64))])) : $.value === null ? (g(), d("div", P, y(h.codeSampleUnavailable), 1)) : (g(), d("div", {
						key: 2,
						id: `${b(Ce)}-example`,
						class: "code-snippet"
					}, [Se.value ? (g(), l(b(fe), {
						key: 1,
						"aria-label": "Request code sample",
						containerClass: "custom-scroll scalar-code-block border rounded-b flex flex-1 max-h-screen",
						contentClass: "language-plaintext whitespace-pre font-code text-base p-2",
						lineHeight: 20,
						role: "region",
						text: $.value
					}, null, 8, ["text"])) : (g(), l(b(le), {
						key: 0,
						class: "bg-b-2 h-full",
						content: $.value,
						hideCredentials: be.value,
						label: ge.value,
						lang: ve.value,
						lineNumbers: ""
					}, null, 8, [
						"content",
						"hideCredentials",
						"label",
						"lang"
					]))], 8, F))]),
					_: 1
				}),
				Z.value || n.$slots.footer || n.$slots["footer-start"] ? (g(), l(b(se), {
					key: 0,
					class: re(["request-card-footer bg-b-3", { "request-card-footer--wraps": !Z.value && n.$slots["footer-start"] }])
				}, {
					default: S(() => [Z.value ? (g(), d("div", I, [Object.keys(V.value).length ? (g(), l(e, {
						key: 0,
						examples: V.value,
						modelValue: H.value,
						"onUpdate:modelValue": me
					}, null, 8, ["examples", "modelValue"])) : u("", !0)])) : n.$slots["footer-start"] ? (g(), d("div", L, [v(n.$slots, "footer-start", {}, void 0, !0)])) : u("", !0), v(n.$slots, "footer", { exampleName: H.value }, void 0, !0)]),
					_: 3
				}, 8, ["class"])) : u("", !0)
			]),
			_: 3
		}, 512)) : h.fallback ? (g(), l(b(C), {
			key: 1,
			class: "request-card dark-mode"
		}, {
			default: S(() => [m(b(w), { class: "request-card-simple" }, {
				default: S(() => [f("div", R, [m(o, {
					as: "span",
					class: "request-method",
					method: h.method
				}, null, 8, ["method"]), v(n.$slots, "header", {}, void 0, !0)]), v(n.$slots, "footer", { exampleName: H.value }, void 0, !0)]),
				_: 3
			})]),
			_: 3
		})) : u("", !0);
	}
});
//#endregion
export { z as default };

//# sourceMappingURL=CodeExample.vue_vue_type_script_setup_true_lang.js.map